module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/theme-modern-4-6c0996e3cab762051fd04587b1c81a42.webp";